module.exports = __webpack_public_path__ + "img/shop-withdraw-icon.8218adb0.png";